import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4 flex items-center gap-4 justify-between border-bottom-grey-3 mb-6" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-primary" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold text-gray-800" }, "Data Komisi Mandoran", -1)

import iconDependency from '@/dependencies/iconDependency'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormHeader',
  setup(__props) {

const iconSvg = iconDependency()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "w-6 h-6 flex items-center justify-center",
          innerHTML: _unref(iconSvg).masterCommission
        }, null, 8, _hoisted_4)
      ]),
      _hoisted_5
    ])
  ]))
}
}

})